import restful from '../vuex'
import axios from 'axios'

const state = {
  ...restful.states('booking'),
  booking_products: []
}

const getters = {
  ...restful.getters('booking'),
  booking_products: (state) => state.booking_products
}

const actions = {
  ...restful.actions('bookings'),
  async booking_products_index ({ commit }, params) {
    if (params.id) {
      const response = await axios.get(`bookings/${params.id}/booking_products`, params)
      commit('booking_products', response.data)
    } else {
      commit('booking_products', [])
    }
  }
}

const mutations = {
  ...restful.mutations('booking'),
  booking_products (state, booking_products) {
    state.booking_products = booking_products
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
